import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.black)[100];
};

const Mobile = ({ color = colors.black[100] }: Props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_572_174)">
        <path
          d="M14.6875 19.6875H5.9375C5.44022 19.6875 4.96331 19.49 4.61167 19.1383C4.26004 18.7867 4.0625 18.3098 4.0625 17.8125V2.8125C4.0625 2.31522 4.26004 1.83831 4.61167 1.48667C4.96331 1.13504 5.44022 0.9375 5.9375 0.9375H14.6875C15.1848 0.9375 15.6617 1.13504 16.0133 1.48667C16.365 1.83831 16.5625 2.31522 16.5625 2.8125V17.8125C16.5625 18.3098 16.365 18.7867 16.0133 19.1383C15.6617 19.49 15.1848 19.6875 14.6875 19.6875Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 16.5625C11.0029 16.5625 11.5625 16.0029 11.5625 15.3125C11.5625 14.6221 11.0029 14.0625 10.3125 14.0625C9.62214 14.0625 9.0625 14.6221 9.0625 15.3125C9.0625 16.0029 9.62214 16.5625 10.3125 16.5625Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_572_174">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Mobile;
